import React, { useEffect, useMemo, useRef, useState } from 'react'
import { TextField, Grid, Typography, Card, Box, Stack, Icon, FormHelperText, Checkbox, FormControlLabel, FormGroup, FormControl, Accordion, AccordionDetails, AccordionSummary, Switch } from '@mui/material';
import MDButton from 'components/MDButton';
import CommonQuillEditor from 'common/editor';
import { useSelector } from 'react-redux';
import { createStaticPage, deleteLegal, getStaticLegal, openSnackbar, updateStaticPage, uploadImage } from '../../redux/slices/common';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ReviewValidation } from 'validations/aboutUs';
import { getData } from 'utilities/common';
import { closeCustomModalDialog, openCustomModalDialog } from '../../redux/slices/modalSlice';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { slugRegexwithunderScor } from 'utilities/common';
import DeleteIcon from 'common/customIcons/delete';

const initialState = {
    'heading': '',
    "sectionType": "review_template",
    "status": true
    , "headerSection": {
        "section": {
            "description": "",
        },
        "status": true,
        "pageTitle": ""
    },
    "displaySettings": {
        "hamburgerMenu": true,
        "footer": true
    },
    "metaProperties": {
        "title": "",
        "description": "",
    },
    'faq': {
        "status": true,
        "section": [
        ]
    },

}

const ReviewPageEdit = ({ legalId, dataProps, fullRoleTabSlug }) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { isUploading = false, isLoading = false, isdltLoading = false, singleLegal } = useSelector((state => state.common));
    const [errors, setErrors] = useState({});
    const uploadedImageRef = useRef();
    const user = getData('login-user-info')
    const parseUser = JSON.parse(user)
    const [formData, setFormData] = useState({ ...initialState, createdBy: parseUser?.name });
    const [searchParams, setSearchParams] = useSearchParams();
    const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);
    const fullRoleTabHeading = useMemo(() => searchParams.get('heading'), [searchParams]);
    const pageExist = useMemo(() => searchParams.get('pageExist'), [searchParams]);
    const [islegalSlugData, setIslegalSlugData] = useState(false)
    const [notSlug, setNotSlug] = useState(false)

    const checkboxGroup = {
        backgroundColor: "#F2F3F7",
        borderRadius: "6px",
        px: 2.5,
        py: 1,
        flexDirection: "row",
        columnGap: 3
    };

    // ************************************************** Submit Handler **************************************************

    const isEmptyObject = (obj) => {
        return obj && Object.keys(obj).length === 0;
    };

    const isBlankError = (errors) => {
        return (
            isEmptyObject(errors.headerSection.section) &&
            errors.headerSection.pageTitle === "" && // Check empty string


            errors.metaProperties.title === "" && // Check empty string
            errors.metaProperties.description === "" && // Check empty string

            (!errors.displaySettings || isEmptyObject(errors.displaySettings))
        );
    };
    //  get page heading
    useEffect(() => {
        if (!fullRoleTabSlug) {
            setFormData((prev) => ({
                prev,
                ...prev,
                heading: fullRoleTabHeading
            }))
        }
    }, [fullRoleTabHeading])

    const handleSubmit = (e) => {

        e.preventDefault();

        if (!fullRoleTabHeading) {
            showError('Save aborted. Please check your inputs for errors.', 'error');
            return;
        }
        if (pageExist === 'yes') {
            showError('Page Already Exist.', 'error');
            return
        }
        const { errors, isValid } = ReviewValidation(formData);

        if (!isValid && !isBlankError(errors)) {

            showError('Save aborted. Please check your inputs for errors.', 'error');
            setErrors(errors);
            return;
        }

        setErrors({});

        const updatedValue = { ...formData, status: dataProps?.status, sectionType: "review_template" }
        if (!islegalSlugData) {
            delete updatedValue.slug;
            // delete updatedValue?.metaProperties?.canonical;      
        }
        delete updatedValue.legalSlugArray
        if (updatedValue?.metaProperties && typeof updatedValue.metaProperties === 'object') {
            updatedValue.metaProperties = Object.fromEntries(
                Object.entries(updatedValue.metaProperties).filter(([key]) => key !== 'canonical')
            );
        }
        // return
        if (fullRoleTabSlug) {
            dispatch(updateStaticPage({ data: updatedValue, id: fullRoleTabHeading, platform: fullRoleTab })).unwrap().then((res) => {
                // dispatch(updateStaticPage({ data: updatedValue, id: fullRoleTabSlug, platform: fullRoleTab })).unwrap().then((res) => {
                showError(res?.message, 'success');
                navigate('/manages/static');
            }).catch((err) => {
                showError(err?.message, 'error');
            });
        } else {
            // delete formData.prev;
            const cleanedFormData = {
                ...formData,
                heading: formData.heading.trimEnd(), // Trims only the end spaces
            };

            delete cleanedFormData.prev; // Remove 'prev' if it exists
            dispatch(createStaticPage(cleanedFormData)).unwrap().then((res) => {
                // dispatch(createStaticPage(formData)).unwrap().then((res) => {
                showError(res?.message, 'success');
                navigate('/manages/static');
            }).catch((err) => {
                showError(err?.message, 'error');
            });
        }
    }

    const showError = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
        }
    };

    // ************************************************** TOPIC section **************************************************

    const updateBannerField = (index, key, value, fileName) => {
        setFormData((prev) => {
            const updatedSections = prev.topicSection?.section.map((item, idx) => {
                if (idx === index) {
                    // If updating image URL, update only the image object inside the section
                    if (key === "imageUrl") {
                        return {
                            ...item,
                            image: {
                                ...item.image, // Keep other image properties unchanged
                                url: value, // Update image URL
                                title: fileName, // Set fileName as title
                                alt: "",
                                description: ""
                            },
                        };
                    } else {
                        // Otherwise, update the regular key-value pair in the section
                        return { ...item, [key]: value };
                    }
                }
                return item;
            });

            return {
                ...prev,
                topicSection: {
                    ...prev.topicSection,
                    section: updatedSections,
                },
            };
        });
    };


    const handleShowOnChange = (field) => {
        setFormData((prev) => ({
            ...prev,
            displaySettings: {
                ...prev.displaySettings,
                [field]: !prev.displaySettings[field],
            },
        }));
    };

    // ************************************************** Get Data **************************************************
    useEffect(() => {
        if (fullRoleTabSlug) {
            // if (!formDataplatform[fullRoleTab]) {
            dispatch(getStaticLegal({ id: fullRoleTabHeading, platform: fullRoleTab })).unwrap().then((res) => {
                // dispatch(getStaticLegal({ id: fullRoleTabSlug, platform: fullRoleTab })).unwrap().then((res) => {
                setNotSlug(true)
                setFormData(prev => ({
                    ...prev,
                    ...res?.legalDetails,
                    heading: fullRoleTabHeading ? fullRoleTabHeading : res?.legalDetails?.heading,
                }));
            }).catch((err) => {
                setNotSlug(false)
                setFormData({
                    ...initialState,
                    createdBy: parseUser?.name || "",
                    heading: fullRoleTabHeading ? fullRoleTabHeading : '',
                    platformAvailability: {
                        hyperwolf: fullRoleTab === 'hyperwolf' ? true : false,
                        hemp: fullRoleTab === 'hemp' ? true : false,
                        stilo: fullRoleTab === 'stilo' ? true : false,
                    },
                });
            });
        } else {
            setFormData(prev => ({
                ...initialState,
                createdBy: parseUser?.name,
                heading: fullRoleTabHeading ? fullRoleTabHeading : '',
                platformAvailability: {
                    hyperwolf: fullRoleTab === 'hyperwolf' ? true : false,
                    hemp: fullRoleTab === 'hemp' ? true : false,
                    stilo: fullRoleTab === 'stilo' ? true : false,
                },
            }));

        }
    }, [fullRoleTabSlug, fullRoleTab])

    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleChangeSlug = (e) => {
        const value = e.target.value;
        setIslegalSlugData(true);
        setFormData((prev => ({
            ...prev,
            slug: slugRegexwithunderScor(value)
        })))
    };

    const deleteHandler = (deleteId) => {
        dispatch(deleteLegal({ slug: deleteId, platform: fullRoleTab }))
            .unwrap()
            .then((res) => {
                showError(res?.message, "success");
                dispatch(closeCustomModalDialog());
                navigate('/manages/static');
            })
            .catch((err) => {
                showError(err?.message, "error");
            });
    };
    const handleRemoveFAQ = (faQIdx) => {
        let FAQArray = [...(formData?.faq?.section || [])];
        FAQArray = FAQArray.filter((faq, _idx) => _idx !== faQIdx);
        setFormData({
            ...formData,
            faq: {
                ...formData?.faq,
                section: FAQArray
            }
        });
    };

    const addFAQHandler = () => {
        let newFAQ = [...(formData?.faq?.section || [])];
        let faqItem = {
            question: '',
            answer: ''
        };
        newFAQ.push(faqItem);
        setFormData({
            ...formData,
            faq: {
                ...formData?.faq,
                section: newFAQ
            }
        });
    };

    const handleChangeFAQ = (value, fieldType, idx) => {
        let FAQArray = [...(formData?.faq?.section || [])];
        if (FAQArray[idx]) {
            FAQArray[idx] = {
                ...FAQArray[idx],
                [fieldType]: value
            };
            setFormData({
                ...formData,
                faq: {
                    ...formData?.faq,
                    section: FAQArray
                }
            });
        }
    };
    return (
        <Box p={4} pt={2} className="static-pages-container">
            {/********************** Select Platform/Show On **********************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        {
                            fullRoleTabSlug &&
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <div className="w-100 mb-4">
                                        <Typography variant='h5' fontWeight="semibold" mb={2}>Page Name</Typography>
                                        <TextField
                                            label='Page Name'
                                            fullWidth
                                            variant='outlined'
                                            name='heading'
                                            value={formData?.heading || ''}
                                            className='form-input'
                                            disabled={true}
                                        />
                                    </div>
                                </Grid>
                                {
                                    notSlug &&
                                    <Grid item xs={12} md={4}>
                                        <div className="w-100 mb-4">
                                            <Typography variant='h5' fontWeight="semibold" mb={2}>Page Slug</Typography>
                                            <TextField
                                                label='Page Slug'
                                                fullWidth
                                                variant='outlined'
                                                name='slug'
                                                value={formData?.slug || ''}
                                                onChange={handleChangeSlug}

                                                className='form-input'
                                            />
                                        </div>
                                    </Grid>
                                }
                            </Grid>
                        }
                        <Typography variant='h5' fontWeight="semibold" mb={2}>Visible On</Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <FormControl sx={{ width: "100%" }}>
                                    <FormGroup className='radio-colors' sx={checkboxGroup}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={formData?.displaySettings?.hamburgerMenu}
                                                    onChange={() => handleShowOnChange('hamburgerMenu')}
                                                />
                                            }
                                            label="Hamburger Menu"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={formData?.displaySettings?.footer}
                                                    onChange={() => handleShowOnChange('footer')}
                                                />
                                            }
                                            label="Footer"
                                        />
                                    </FormGroup>
                                </FormControl>
                                {Boolean(errors?.displaySettings) && <FormHelperText error>{errors?.displaySettings}</FormHelperText>}

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Card>

            {/********************** Meta Tags **********************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Typography variant='h5' fontWeight="semibold" mb={2}>Meta Properties</Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                        <TextField
                            label="Meta Title"
                            className="form-input"
                            fullWidth
                            placeholder="Meta Title"
                            value={formData?.metaProperties?.title}
                            onChange={(e) => setFormData((prev) => ({ ...prev, metaProperties: { ...prev?.metaProperties, title: e.target.value } }))}
                            error={Boolean(errors?.metaProperties?.title)}
                            helperText={errors?.metaProperties?.title}
                        />
                        <span className='drag_drop'>
                            Character Count: {formData?.metaProperties?.title?.length || 0} <span>(Recommended Characters: 60)</span>
                        </span>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <TextField
                            label="Meta Description"
                            className="form-input"
                            fullWidth
                            placeholder="Meta Description"
                            value={formData?.metaProperties?.description}
                            onChange={(e) => setFormData((prev) => ({ ...prev, metaProperties: { ...prev?.metaProperties, description: e.target.value } }))}
                            error={Boolean(errors?.metaProperties?.description)}
                            helperText={errors?.metaProperties?.description}

                        />
                        <span className='drag_drop'>
                            Character Count: {formData?.metaProperties?.description?.length || 0} <span>(Recommended Characters: 160)</span>
                        </span>
                    </Grid>
                </Grid>
            </Card>

            {/********************** Top Banner **********************/}
            <Accordion expanded={expanded === 'header'} onChange={handleChange('header')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panelheading-content"
                    id="panelheading-header"
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>Header Section</Typography>
                        <FormControlLabel
                            onClick={(e) => e.stopPropagation()}
                            control={
                                <Switch
                                    checked={formData?.headerSection?.status}
                                    onChange={() =>
                                        setFormData((prev) => ({ ...prev, headerSection: { ...prev.headerSection, status: !prev.headerSection.status, } }))
                                    }
                                />
                            }
                            label={formData?.headerSection?.status ? "Visible" : "Hidden"}
                        />
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>Page Title(H1)</Typography>
                                    <TextField
                                        label="Page Title(H1)"
                                        className="form-input"
                                        fullWidth
                                        placeholder="Page Title(H1)"
                                        value={formData?.headerSection?.pageTitle}
                                        onChange={(e) =>
                                            setFormData((prev) => ({ ...prev, headerSection: { ...prev.headerSection, pageTitle: e.target.value }, }))
                                        }
                                        error={Boolean(errors?.headerSection?.pageTitle)}
                                        helperText={errors?.headerSection?.pageTitle}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                                    <CommonQuillEditor
                                        allowHeading={false}
                                        value={formData?.headerSection?.section?.description || ''}
                                        onChange={(value) => setFormData((prev) => ({
                                            ...prev,
                                            headerSection: { ...prev?.headerSection, section: { ...prev?.headerSection?.section, description: value, }, },
                                        }))
                                        }
                                    />
                                    {Boolean(errors?.headerSection?.section?.description) && <FormHelperText error>{errors?.headerSection?.section?.description}</FormHelperText>}
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>Info Text</Typography>
                                    <TextField
                                        label="Info Text"
                                        className="form-input"
                                        fullWidth
                                        placeholder="Info Text"
                                        value={formData?.bottomSection?.section?.title || ''}
                                        onChange={(e) =>
                                            setFormData((prev) => ({ ...prev, bottomSection: { ...prev.bottomSection, section: { ...prev?.bottomSection?.section, title: e.target.value }, }, }))
                                        }
                                        error={Boolean(errors?.bottomSection?.section?.title)}
                                        helperText={errors?.bottomSection?.section?.title}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Typography variant='h5' fontWeight="semibold" mb={2}>Content Section</Typography>
                {/* <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography> */}
                <CommonQuillEditor
                    allowHeading={false}
                    value={formData?.bottomSection?.section?.description || ''}
                    onChange={(value) => setFormData((prev) => ({
                        ...prev,
                        bottomSection: { ...prev?.bottomSection, section: { ...prev?.bottomSection?.section, description: value, }, },
                    }))
                    }
                />
            </Card>

            {/********************** FAQ **********************/}
            <Accordion expanded={expanded === 'faqSection'} onChange={handleChange('faqSection')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panelfaqSection-content"
                    id="panelfaqSection-header"
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>FAQs</Typography>
                        <FormControlLabel
                            onClick={(e) => e.stopPropagation()}
                            control={
                                <Switch
                                    checked={formData?.faq?.status}
                                    onChange={() => setFormData((prev) => ({ ...prev, faq: { ...prev.faq, status: !prev.faq.status, } }))}
                                />
                            }
                            label={formData?.faq?.status ? "Visible" : "Hidden"}
                        />
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    {
                        formData?.faq?.section?.length > 0 ? <>
                            {
                                formData?.faq?.section?.map(((faq, idx) => {
                                    return <Grid key={idx} item xs={12} sm={12} lg={12} my={2}>
                                        <Box width={'100%'} className="faq-sec-rep">
                                            <Box display='flex' flexDirection='column' justifyContent='space-between' alignItems={'flex-start'} className="mb-3">
                                                <Box width={'100%'} display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                                                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A">Question</Typography>
                                                    <MDButton
                                                        sx={{ minWidth: 'auto', p: 0 }}
                                                        size="small"
                                                        variant='text'
                                                        onClick={() => handleRemoveFAQ(idx)}
                                                        style={{ color: "#fd4438" }}
                                                    >
                                                        <DeleteIcon width="1rem" height="1rem" style={{ color: "#fd4438" }} />
                                                    </MDButton>
                                                </Box>
                                                <Box width={'100%'}>

                                                    <CommonQuillEditor
                                                        allowHeading={false}
                                                        allowImage={false}
                                                        value={faq?.question || ''}
                                                        onChange={(value) => handleChangeFAQ(value, 'question', idx)}
                                                    />
                                                    {Boolean(errors?.faq?.section[idx]?.question) && (
                                                        <FormHelperText error>{errors?.faq?.section[idx]?.question}</FormHelperText>
                                                    )}
                                                </Box>
                                            </Box>
                                            <Box display='flex' justifyContent='center' alignItems={'flex-start'}>
                                                <Box width={'100%'}>
                                                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Answer</Typography>
                                                    <CommonQuillEditor
                                                        allowHeading={false}
                                                        allowImage={false}
                                                        value={faq?.answer || ''}
                                                        onChange={(value) => handleChangeFAQ(value, 'answer', idx)}
                                                    />
                                                    {Boolean(errors?.faq?.section[idx]?.answer) && (
                                                        <FormHelperText error>{errors?.faq?.section[idx]?.answer}</FormHelperText>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Grid>;
                                }))
                            }
                        </> : <Grid item xs={12} sm={12} lg={12} mt={3}>
                            <Box display='flex' justifyContent='space-between' alignItems={'center'}>
                                <MDButton
                                    type='button'
                                    color='primary'
                                    size='medium'
                                    variant='outlined'
                                    sx={{ minWidth: '180px' }}
                                    onClick={addFAQHandler}
                                >
                                    <Icon>add</Icon>&nbsp;Add FAQ
                                </MDButton>
                            </Box>
                        </Grid>
                    }

                    {
                        formData?.faq?.section?.length > 0 && <Grid item xs={12} mt={3}>
                            <MDButton
                                type='button'
                                color='primary'
                                size='medium'
                                variant='outlined'
                                sx={{ minWidth: '180px' }}
                                onClick={addFAQHandler}
                            >
                                <Icon>add</Icon>&nbsp;Add More
                            </MDButton>
                        </Grid>
                    }
                </AccordionDetails>
            </Accordion>

            {/********************** Save, Cancel Buttons **********************/}
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2} mb={2}>
                        <MDButton
                            sx={{ minWidth: '160px' }}
                            type='button'
                            variant='contained'
                            color='primary'
                            onClick={handleSubmit}
                            disabled={isLoading}
                            isLoading={isLoading}
                        >
                            {/* Save */}
                            {fullRoleTabSlug ? 'Update' : 'Save'}

                        </MDButton>
                        {
                            notSlug && <MDButton
                                sx={{ minWidth: '160px', backgroundColor: '#fdd5d3', color: '#FD4438' }}
                                type='button'
                                variant='contained'
                                color='error'
                                onClick={() => {
                                    dispatch(openCustomModalDialog({ modalData: { deleteHandler, deleteId: fullRoleTabHeading, deleteType: "page" }, modal: 'DELETE_MODAL' }));
                                }}
                            >
                                Delete
                            </MDButton>
                        }
                        <MDButton
                            sx={{ minWidth: '160px' }}
                            type='button'
                            variant='outlined'
                            color='dark'
                            onClick={() => navigate('/manages/static')}
                        >
                            Cancel
                        </MDButton>
                    </Stack>
                </Grid>
            </Grid>

        </Box>
    )
}

export default ReviewPageEdit